import * as actions from './actions'

// initial state
const state = {
  prepaidCard: {
    card_info: {
      card_no: '',
      card_type_cd: '',
      pin_cd: '',
      issue_date: '',
      lapse_datetime: null,
      blocking_datetime: null,
      card_status_change_reason: null,
      final_usage_datetime: '',
      card_status: '',
      card_expire_datetime: null,
      activate_datetime: '',
      activate_shop_cd: '',
      actibate_tid: '',
      member_no: null,
      rank: '',
      stamp_count: null,
      ceiling_stamp_count: null,
      stamp_preference_interval_count: null,
      stamp_expire_datetime: null,
      value_amount_sum: 0,
      point_count_sum: null,
      initial_limit_value_amount: 0,
      limit_value_amount_sum: 0,
      extention_value_amount_sum: null,
      no_limit_value_amount_sum: null,
      limit_point_count_sum: null,
      extention_point_count_sum: null,
      no_limit_point_count_sum: null,
      extention_value_expire_datetime: null,
      extention_point_expire_datetime: null,
      limit_value_list: null,
      limit_point_list: null
    },
    initial_benefit_used: null
  }
}

// getters
const getters = {
  prepaidCard: (state) => {
    return state.prepaidCard
  }
}

// mutations
const mutations = {
  SET_PREPAID_CARD (state, data) {
    state.prepaidCard = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
